import Modal from "@Generic/modal/Modal";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useTranslation} from "@Translation/hooks/useTranslation";

function MessageSent() {
    const {
        thank_you_for_reaching_out: thankYouForReachingOutLabel,
        we_ll_send_you_request_asap: weLlSendYouRequestAsapLabel,
        if_any_more_questions: ifAnyMoreQuestionsLabel,
        our_bus_network: ourBusNetworkLabel,

    } = useTranslation("bus_rental.successful_request")
    const homePageUrl = useAppSelector((state) => state?.page.siteUrl)

    const handleClose = () => {
        window.location.href = homePageUrl
    }

    return (
        <Modal
            title={thankYouForReachingOutLabel}
            handleClick={handleClose}
            message={(
                <div className="contact--message-sent">
                    {weLlSendYouRequestAsapLabel}
                    <br/>
                    <br/>
                    {ifAnyMoreQuestionsLabel}
                </div>
            )}
            buttonText={ourBusNetworkLabel}
        />
    )
}

export default MessageSent